import React from 'react';
import type { NextAction } from '../types/meeting';

interface TodoListProps {
  nextActions: NextAction[];
}

const TodoList: React.FC<TodoListProps> = ({ nextActions }) => {
  return (
    <div className="panel-section">
      <div className="section-title">
        <span className="section-icon material-symbols-outlined">assignment</span>
        次回までにやるべきこと
      </div>
      <div className="todo-list" id="todo-list">
        {nextActions.length === 0 ? (
          <div className="empty-state" id="todo-empty-state">
            <span className="material-symbols-outlined empty-state-icon">pending_actions</span>
            <div className="empty-state-text">
              会議の内容から次回までにやるべきことを提案します
            </div>
          </div>
        ) : (
          nextActions.map((action, index) => {
            // 担当と期限を処理（「不明」を除外）
            const metaParts: string[] = [];
            if (action.assignee && action.assignee !== '不明') {
              metaParts.push(`担当: ${action.assignee}`);
            }
            if (action.deadline && action.deadline !== '不明') {
              metaParts.push(`期限: ${action.deadline}`);
            }

            const taskText =
              metaParts.length > 0
                ? `${action.task} (${metaParts.join(' | ')})`
                : action.task;

            return (
              <div key={index} className="todo-item">
                <div className="todo-number">{index + 1}</div>
                <div className="todo-text">{taskText}</div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default TodoList;
